import { invariant } from "@searchui-searchforms/shared/utils";
import type { UserPreferences } from "@/entities/user-preferences";

export const prepareGivenNameWithUPS = (
    firstNameExactness: UserPreferences["UserPreferences"]["FirstNameExactness"],
) => {
    invariant(firstNameExactness, "firstNameExactness is not defined");
    return {
        isExact: firstNameExactness.Exact,
        flags: {
            phonetic: firstNameExactness.Phonetic,
            initials: firstNameExactness.Initials,
            similar: firstNameExactness.Similar,
        },
    };
};

export const prepareLastNameWithUPS = (lastNameExactness: UserPreferences["UserPreferences"]["LastNameExactness"]) => {
    invariant(lastNameExactness, "lastNameExactness is not defined");

    return {
        isExact: lastNameExactness.Exact,
        flags: {
            phonetic: lastNameExactness.Phonetic,
            similar: lastNameExactness.Similar,
            soundex: lastNameExactness.Soundex,
        },
    };
};
